import React from 'react'
import { MotivationInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import search from '../../../../../assets/images/icons/search.svg'
import copy from '../../../../../assets/images/icons/copy.svg'

type Props = {
  startEdit: (el: MotivationInterface) => void
  startDuplicate: (el: MotivationInterface) => void
  el: MotivationInterface
  showDetails: (el: MotivationInterface) => void
}

export const ListItem = ({ startDuplicate, el, showDetails }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        <div className={classes.nameAndDescription}>
          <div className={classes.name}>{shortenText(el.name, 50)}</div>
          <div className={classes.description}>{shortenText(el.description || '', 100)}</div>
        </div>

        <div className={classes.settings}>
          {el.costPerOrder && <div className={classes.settingsItem}>{el.costPerOrder} ₽/заказ</div>}
          {el.revenuePercent && (
            <div className={classes.settingsItem}>{el.revenuePercent}% от выручки</div>
          )}
          {el.bonusForOrdersCount && el.ordersCountTarget && (
            <div className={classes.settingsItem}>
              +{el.bonusForOrdersCount} ₽ за {el.ordersCountTarget} заказов
            </div>
          )}
        </div>
      </div>
      <div className={classes.buttons}>
        <IconButton display onClick={() => showDetails(el)} icon={search} alt="Детали" small />
        <IconButton display onClick={() => startDuplicate(el)} icon={copy} alt="Копировать" small />
      </div>
    </div>
  )
}
